<template>
	<div class="d-flex align-items-center justify-content-center text-muted" :style="{'font-size': textSize}" :class="textClasses">
		<fa-icon v-if="icon" :icon="icon" :style="{'font-size': iconSize}" class="mr-2" :class="iconClasses" />{{ text }}
	</div>
</template>

<script>
export default {
	name: 'GhostMessage',
	props: {
		// TEXT
		text: {
			type: String,
			default: '',
		},
		textSize: {
			type: String,
			default: '14px',
		},
		textClass: {
			type: String,
			default: '',
		},
		// ICON
		icon: {
			type: Array,
			default: null,
		},
		iconSize: {
			type: String,
			default: '22px',
		},
		iconClass: {
			type: String,
			default: '',
		},
		// OTHERS
		orientation: {
			type: String,
			default: 'row',
		},
		animated: {
			type: String,
			default: null,
		},
		infinite: {
			type: Boolean,
			default: false,
		},
		faster: {
			type: Boolean,
			default: false,
		},
		delay: {
			type: Number,
			default: 1,
		},
	},
	computed: {
		iconClasses() {
			if (this.animated) {
				return `animated ${this.infinite ? 'infinite' : ''} ${this.faster ? 'faster' : ''} ${this.animated} delay-${this.delay}s ${this.iconClass}`;
			}

			return this.iconClass;
		},
		textClasses() {
			return `flex-${this.orientation} ${this.textClass}`;
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
